<form class="drop-padding" (ngSubmit)="updateDescription()">
  <mat-form-field appearance="outline">
    <mat-label>Наименование</mat-label>
    <input matInput type="text" [formControl]="descriptionControl" />
  </mat-form-field>
  <button mat-flat-button color="primary" type="submit">Сохранить</button>
</form>
